// validationPatterns.js

export const mobileRegex = /^[0-9]{10}$/;

export const numaricRegex = /^\d*$/;

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const pincodeRegex = /^[0-9]{6}$/;

export const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

export const aadhaarRegex = /^[0-9]{12}$/;

export const specialCharRegex = /[!@#$%^&*(),.?":{}|<>]/;

export const passwordRegex = /^(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}$/;

export const accountNumberRegex = /^\d{9,18}$/;


